import React from 'react';

import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import InfiniteScroll from 'react-infinite-scroll-component';
import {setPubPageFiltersAC, pubsPerPage} from 'store/pubs/pubSlice';

import {PubPageTableItem} from './PubPageTableItem';

export const PubPageTableBody = () => {
  const dispatch = useSetGlobalState();

  const {filters, pubs} = useGlobalState((state) => state.pubs);

  const hasMore = pubs.totalCount > pubs.list.length;

  const handlePageChange = (page: number) => {
    dispatch(setPubPageFiltersAC({...filters, perPage: (page + 1) * pubsPerPage, page: page + 1}));
  };

  return (
    <div className="pub-pages__body" id="scrollable-div">
      <InfiniteScroll
        loader={<></>}
        dataLength={pubs.list.length}
        next={() => handlePageChange(filters.page)}
        hasMore={hasMore}
        style={{overflow: 'hidden'}}
        scrollableTarget="scrollable-div"
      >
        {pubs.list.map((pub) => {
          return <PubPageTableItem key={pub.id} pub={pub} />;
        })}
      </InfiniteScroll>
    </div>
  );
};
